export default "__VITE_ASSET__DUum0TvP__"